<template>
  <v-sheet class="about-section pb-sm-0 pb-5" color="grey lighten-2">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <v-container v-if="!loading" class="about-section-content">
        <v-row align-lg="start">
          <v-col class="pb-0" v-if="image" cols="12" md="6">
            <TitleWidget
              v-if="smAndDown"
              :align="!smAndDown ? 'left' : 'center'"
            >
              <span class="secondary--text">
                {{ about.title }}
              </span>
            </TitleWidget>
            <img
              width="100%"
              class="d-block mt-6 mt-sm-0"
              :src="image"
              :alt="about.title"
            />
          </v-col>
          <v-col class="pt-lg-8" cols="12" :md="image ? 6 : 12">
            <TitleWidget
              v-if="!smAndDown"
              :align="!smAndDown ? 'left' : 'center'"
            >
              <span class="secondary--text">
                {{ about.title }}
              </span>
            </TitleWidget>
            <div
              class="
                mt-3 mt-sm-5
                ck-content
                font-weight-medium
                text-h6
                grey--text
                text--lighten-4
                about-section-text
              "
            >
              <span class="font-barlow" v-html="about.intro"></span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
const _config = {
  mod: "about",
};
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    about() {
      return this.$rest(_config.mod).item;
    },
    image() {
      const featuredPath = this.$rest(_config.mod).item.img?.featured?.path;
      return featuredPath
        ? this.files + featuredPath + "?resize=1&w=960"
        : null;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.about-section {
  position: relative;
  img {
    -webkit-mask-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 87%,
      rgba(0, 0, 0, 0.7987570028011204) 92%,
      rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 87%,
      rgba(0, 0, 0, 0.7987570028011204) 92%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  &::after {
    pointer-events: none;
    content: "";
    width: 100%;
    height: 288px;
    position: absolute;
    left: 0;
    bottom: -1px;
    background-image: url(../../assets/img/bg_about.png);
    background-size: contain;
    background-position: bottom;
    z-index: 1;
    @media (max-width: 1264px) {
      display: none;
    }
  }
  &::before {
    pointer-events: none;
    content: "";
    width: 100%;
    height: 288px;
    position: absolute;
    left: 0;
    bottom: -1px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 74%,
      rgba(208, 40, 55, 1) 91%
    );

    z-index: 4;
    @media (max-width: 960px) {
      display: none;
    }
  }
  &-content {
    z-index: 2;
    position: relative;
  }
  &-text {
    line-height: 120% !important;
  }
}
</style>
